
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './utils/language'
import getIpConfigJson from '@/utils/getIpConfig.js'
import axios from 'axios'

Vue.config.productionTip = false

getIpConfigJson().then((res) => {
  axios.defaults.baseURL = res.baseUrl
  Vue.prototype.$IpConfig = res
  new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js